import { GerrieAddAccountParameter } from "@gerrieDev/Handlers/GerrieUpdateAccount";
import { GerrieAccountInvoiceNumberValidation, GerrieUpdateAccountModel } from "@gerrieDev/Services/GerrieApiModels";
import { post, ServiceResult } from "@insite/client-framework/Services/ApiService";

export async function gerrieValidateAccountInvoiceNumber(
    model: GerrieAccountInvoiceNumberValidation,
): Promise<ServiceResult<boolean>> {
    try {
        const result = await post<GerrieAccountInvoiceNumberValidation, boolean>(
            "/api/v1/GerrieAccount/validate-account-invoice",
            model,
        );
        if (result === true) {
            return {
                result,
                successful: true,
            };
        }
        return {
            successful: false,
            errorMessage: "Invalid combination",
        };
    } catch (error) {
        return {
            successful: false,
            errorMessage: "Invalid combination",
        };
    }
}

export async function gerrieUpdateAccount(parameter: GerrieAddAccountParameter): Promise<ServiceResult<string>> {
    const accountUpdateModel: GerrieUpdateAccountModel = {
        isNewCustomer: parameter.accountInfo.isNewCustomer,
        accountNumber: parameter.accountInfo.accountNumber,
        invoiceNumber: parameter.accountInfo.invoiceNumber,
        firstName: parameter.accountInfo.firstName,
        lastName: parameter.accountInfo.lastName,
        companyName: parameter.accountInfo.companyName,
        emailAddress: parameter.email,
        address1: parameter.accountInfo.address1,
        address2: parameter.accountInfo.address2,
        city: parameter.accountInfo.city,
        postalCode: parameter.accountInfo.postalCode,
        phoneNumber: parameter.accountInfo.phoneNumber,
        country: parameter.accountInfo.country,
        state: parameter.accountInfo.state,
        faxNumber: parameter.accountInfo.faxNumber,
        uri: "",
        properties: {},
    };
    try {
        const accountModel = await post<GerrieUpdateAccountModel, string>(
            "/api/v1/GerrieAccount/update-account",
            accountUpdateModel,
        );
        return {
            result: accountModel,
            successful: true,
        };
    } catch (error) {
        if ("status" in error && error.status === 400 && error.errorJson && error.errorJson.message) {
            return {
                successful: false,
                errorMessage: error.errorJson.message,
            };
        }
        throw error;
    }
}
